import { Controller } from '@hotwired/stimulus'

export default class FacebookEventsController extends Controller {
  static values = {
    eventName: String,
    eventId: String,
    orderPrice: Number
  }

  connect () {
    window.facebookEventRequests ||= {}

    if (!window.fbq || window.facebookEventRequests[this.eventIdValue]) {
      return
    }

    window.fbq('track', this.eventNameValue, this.properties, this.dedupData)
    window.facebookEventRequests[this.eventIdValue] = true
  }

  get properties () {
    if (this.hasOrderPriceValue) {
      return { value: this.orderPriceValue, currency: 'MXN' }
    } else {
      return {}
    }
  }

  get dedupData () {
    return { eventID: this.eventIdValue }
  }
}
